export default __webpack_public_path__ + "static/puro-ccaf07f732a75ac470ec3571de6a968e.png";